import { useContext, useMemo } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { DrawerScreen } from '@/types/screens';
import { PaymentMethodEnum } from '@/types/common';

const SCREENS_TO_HIDE_EXPRESS_CHECKOUT = [DrawerScreen.SAVED_CARDS, DrawerScreen.OTHER_PAYMENT_METHOD];
const SCREENS_TO_HIDE_PAYMENT_METHODS = [DrawerScreen.SAVED_CARDS, DrawerScreen.OTHER_PAYMENT_METHOD];

export const usePaymentSectionVisibility = () => {
  const {
    viewer: { screen },
    paymentMethodSelected,
  } = useContext(CheckoutContext);
  const isOtherPaymentMethod = paymentMethodSelected === PaymentMethodEnum.OTHER;

  return useMemo(
    () => ({
      shouldShowExpressCheckoutByScreen:
        !SCREENS_TO_HIDE_EXPRESS_CHECKOUT.includes(screen as DrawerScreen) && !isOtherPaymentMethod,
      shouldShowPaymentMethodsByScreen:
        !SCREENS_TO_HIDE_PAYMENT_METHODS.includes(screen as DrawerScreen) && !isOtherPaymentMethod,
    }),
    [screen, isOtherPaymentMethod]
  );
};
